import { animate, timeline } from 'motion';

import { Component } from '@verndale/core';
import Splitting from 'splitting';
import videoHeroV2 from './videoHeroV2';
import { last } from 'lodash';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      slider: this.el.querySelector('.swiper-container'),
      next: this.el.querySelector('.home-hero-v2__next-button'),
      nextLabel: this.el.querySelector('.next-button__label'),
      slideWrapper: this.el.querySelector('.swiper-wrapper'),
      thumbnailWrapper: this.el.querySelector('.thumbnail__wrapper'),
      thumbnailWrapperVideo: this.el.querySelector(
        '.thumbnail__wrapper video source'
      ),

      slides: this.el.querySelectorAll('.swiper-slide')
    };

    this.buttonHoverClass = 'home-hero-v2__next-button--hover';
    this.videoHeroV2 = '[data-module="videoHeroV2"]';
    this.currentSlide = 0;
    this.displaySlide = 0;
    this.originalWindowWidth = window.innerWidth;

    this.initHero();
  }

  addListeners() {
    this.dom.next.addEventListener(
      'mouseover',
      this.handleMouseOver.bind(this)
    );
    this.dom.next.addEventListener('focusin', this.handleMouseOver.bind(this));
    this.dom.next.addEventListener(
      'mouseleave',
      this.handleMouseLeave.bind(this)
    );
    this.dom.next.addEventListener(
      'focusout',
      this.handleMouseLeave.bind(this)
    );
    this.dom.next.addEventListener('click', this.handleNextSlide.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  initHero() {
    this.slideHeightCalculator();
    this.initDuplicateSlide();
    this.initSplitting();
    this.initVideos();
    this.checkAutoplayVideos();
    this.setNextButtonData(this.slides[this.displaySlide + 1]);
    this.el.style.visibility = 'visible';
  }

  slideHeightCalculator() {
    let tallestSlideBlockSize = 0;
    this.el.style = `--slides-block-size: ${tallestSlideBlockSize}px; visibility: visible;`;
    this.dom.slides.forEach((slide, index) => {
      slide.id = index;
      const article = slide.querySelector('article');
      if (article.offsetHeight > tallestSlideBlockSize)
        tallestSlideBlockSize = article.offsetHeight;
    });

    this.el.style = `--slides-block-size: ${tallestSlideBlockSize}px; visibility: visible;`;
  }

  contentHeightCalculator() {
    let tallestContentHeight = 0;
    this.dom.slideWrapper.style = `--content-block-size: ${tallestContentHeight}px`;
    this.content.forEach(content => {
      if (content.offsetHeight > tallestContentHeight)
        tallestContentHeight = content.offsetHeight;
    });

    this.dom.slideWrapper.style = `--content-block-size: ${tallestContentHeight}px`;
  }

  initDuplicateSlide() {
    const lastSlide = this.dom.slides[0].cloneNode(true);
    const headerTag = lastSlide.querySelector('h1');
    const span = document.createElement('span');

    span.innerHTML = headerTag.innerHTML;
    span.classList.add('home-hero-v2--content__header');
    headerTag.replaceWith(span);

    this.dom.slideWrapper.appendChild(lastSlide);
    this.slides = this.el.querySelectorAll('.swiper-slide');
    this.content = this.el.querySelectorAll('.home-hero-v2__content');
    this.contentHeightCalculator();
    this.videoOriginal = this.el.querySelectorAll(
      '.video-hero-v2__video--original'
    );

    this.slides.forEach((slide, index) => {
      if (index !== this.displaySlide) slide.style.visibility = 'hidden';
    });

    window.scrollTo(0, 0);
  }

  initSplitting() {
    this.content.forEach(content => {
      content.lineSplit = Splitting({
        target: content,
        by: 'lines'
      });
    });
  }

  initVideos() {
    this.videoModules = [];
    [...this.getHeroVideos()].forEach((video, index) => {
      const _video = new videoHeroV2(video);

      this.videoModules.push(_video);
      if (index === 0) {
        this.videoModules[0].pauseVideo();
      }
    });
  }

  checkAutoplayVideos() {
    [...this.getHeroVideos()].forEach(videos => {
      const videosHero = [...videos.querySelectorAll('.video-hero-v2__video')];
      videosHero.forEach(video => {
        video.removeAttribute('autoplay');
        video.load();
      });
    });

    this.firstVideo = [false];

    this.slides[this.displaySlide]
      .querySelectorAll('.video-hero-v2__video')
      .forEach((video, index) => {
        video.addEventListener('canplaythrough', e => {
          this.firstVideo[index] = true;
          if (this.firstVideo.findIndex(video => !video) === -1) {
            this.videoModules[0].playVideo();
          }
        });
      });
  }

  handleNextSlide() {
    const prevSlide = this.slides[this.displaySlide];
    const pause = this.slides[this.displaySlide].querySelector(
      '.video-hero-v2__pause-button'
    );
    const play = this.slides[this.displaySlide].querySelector(
      '.video-hero-v2__play-button'
    );
    this.slideChange();
    if (pause.style.display !== 'block') {
      play.style.display = 'none';
      pause.style.display = 'block';
    }
    const nextSlide =
      this.displaySlide === this.slides.length - 2
        ? this.slides[0]
        : this.slides[this.displaySlide + +1];

    this.setNextButtonData(nextSlide);
    this.stopPrevVideo(prevSlide);
    this.playNextVideo(this.slides[this.displaySlide]);
  }

  handleMouseOver(event) {
    this.getClosestElement(event.target, '.next-button').classList.add(
      this.buttonHoverClass
    );
  }

  handleMouseLeave(event) {
    this.removeButtonHoverClass(event.target);
  }

  handleResize() {
    if (this.originalWindowWidth === window.innerWidth) {
      return;
    }
    this.contentHeightCalculator();
    this.slideHeightCalculator();
    this.originalWindowWidth = window.innerWidth;
  }

  stopPrevVideo(prevSlide) {
    prevSlide
      .querySelectorAll(`${this.videoHeroV2} .video-hero-v2__video`)
      .forEach(video => {
        setTimeout(() => {
          video.pause();
        }, 1000);
      });
  }

  playNextVideo(nextSlide) {
    nextSlide
      .querySelectorAll(`${this.videoHeroV2} .video-hero-v2__video`)
      .forEach(video => {
        video.play();
      });
  }

  slideChange() {
    if (!this.animating) {
      const nextSlide =
        this.displaySlide === this.slides.length - 2
          ? 0
          : this.displaySlide + 1;

      const prevSlide = this.displaySlide;
      const loop = this.displaySlide === this.slides.length - 2;
      const showSlide = loop ? this.displaySlide + 1 : nextSlide;
      this.displaySlide = nextSlide;
      this.animating = true;

      const hideSequence = this.content[prevSlide].lineSplit[0].lines.reduce(
        (sequence, line, index) => {
          const element = line[0].closest('.btn-v2--gold')
            ? line[0].closest('.btn-v2--gold')
            : line;

          const delay = line[0].closest('.btn-v2--gold')
            ? 0.03 * this.content[prevSlide].lineSplit[0].lines.length
            : 0.03 * index;

          if (line[0].closest('.btn-v2--white')) {
            return sequence;
          }
          const lineSequence = [
            element,
            {
              opacity: [1, 0],
              transform: ['translate(0, 0)', 'translate(-100px, 0)']
            },
            { at: delay },
            { duration: 0.1 }
          ];
          sequence.push(lineSequence);
          return sequence;
        },
        []
      );

      const showSequence = this.content[showSlide].lineSplit[0].lines.reduce(
        (sequence, line, index) => {
          const element = line[0].closest('.btn-v2--gold')
            ? line[0].closest('.btn-v2--gold')
            : line;

          const delay = line[0].closest('.btn-v2--gold')
            ? 0.03 * this.content[showSlide].lineSplit[0].lines.length
            : 0.03 * index;

          if (line[0].closest('.btn-v2--white')) {
            return sequence;
          }

          if (Array.isArray(element)) {
            element.forEach(el => (el.style.opacity = '0'));
          } else {
            element.style.opacity = '0';
          }

          const lineSequence = [
            element,
            {
              opacity: [0, 1],
              transform: ['translate(100px, 0)', 'translate(0, 0)']
            },
            { at: 0.35 + delay },
            { duration: 0.05 }
          ];
          sequence.push(lineSequence);
          return sequence;
        },
        []
      );

      this.slides[showSlide].style.visibility = 'visible';

      if (this.videoOriginal[prevSlide].anim) {
        this.videoOriginal[prevSlide].anim.stop();
      }

      animate(
        this.videoOriginal[showSlide],
        {
          clipPath: ['inset(0 0 1px 100%)', 'inset( 0 0 1px 0)']
        },
        {
          duration: 0.4
        }
      );

      this.hideTransition = timeline(hideSequence);

      this.showTransition = timeline(showSequence).finished.then(() => {
        if (loop) {
          this.content[this.displaySlide].lineSplit[0].lines.forEach(line => {
            if (!line[0].closest('.btn-v2--white')) {
              const element = line[0].closest('.btn-v2--gold')
                ? line[0].closest('.btn-v2--gold')
                : line;

              if (Array.isArray(element)) {
                element.forEach(
                  el => (el.style = 'opacity: 1; transform: translate(0)')
                );
              } else {
                element.style = 'opacity: 1; transform(0): : translate(0)';
              }
            }
          });

          this.slides[this.displaySlide].style.visibility = 'visible';
        }
        this.animating = null;
        this.slides.forEach((slide, index) => {
          if (index !== this.displaySlide) slide.style.visibility = 'hidden';
        });
      });
    }
  }

  removeButtonHoverClass(element) {
    this.getClosestElement(element, '.next-button').classList.remove(
      this.buttonHoverClass
    );
  }

  clearNextButtonData() {
    this.dom.thumbnailWrapperVideo.src = '';
    this.removeButtonHoverClass(this.dom.next);
  }

  setNextButtonData(nextSlide) {
    this.clearNextButtonData();

    this.setNextSliderButton({
      label: nextSlide.dataset.nextLabel,
      image: this.getVideoSrc(nextSlide)
    });
  }

  setNextSliderButton({ label, image }) {
    const prefix = this.dom.nextLabel.dataset.label;
    this.dom.thumbnailWrapperVideo.src = image;
    this.dom.thumbnailWrapperVideo.alt = label;
    this.dom.nextLabel.innerHTML = `${prefix} ${label}`;

    const video = this.dom.thumbnailWrapper.querySelector('video');

    video.load();
    video.play();

    if (video.readyState >= 3) {
      video.play();
    }
  }

  getClosestElement(element, className) {
    return element.closest(className);
  }

  getHeroVideos() {
    return this.el.querySelectorAll(`${this.videoHeroV2}`);
  }

  getVideoSrc(element) {
    return element.querySelector(
      '.home-hero-v2__media-wrapper .video-hero-v2__video source'
    ).src;
  }
}

export default Module;
